export default __webpack_public_path__ + "static/bg-blood-a09fb89081db207bc0e58e87507e69a7.webp";